"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _createIcon = _interopRequireDefault(require("../../utils/createIcon"));
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _particles = require("../../utils/particles");
var _pickAndRemoveFromObject = _interopRequireDefault(require("../../utils/pickAndRemoveFromObject"));
var _shortenNumber = require("../../utils/shortenNumber");
var _useLongPress = _interopRequireDefault(require("../../utils/useLongPress"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
var _excluded = ["size", "icon", "total", "className", "onClick", "onLongPress", "disabled", "acknowledge", "placement", "overrides"];
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var common = _commonProps.defaultCommonProps;
var vars = (0, _initVars.default)({
  applied: common,
  variables: [{
    key: "reactionSize"
  }, {
    key: "reactionScale"
  }, {
    key: "reactionCursor"
  }, {
    key: "reactionFontSize"
  }]
});
var Reaction = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? "medium" : _props$size,
    icon = props.icon,
    total = props.total,
    className = props.className,
    onClick = props.onClick,
    onLongPress = props.onLongPress,
    disabled = props.disabled,
    acknowledge = props.acknowledge,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? "left" : _props$placement,
    _props$overrides = props.overrides,
    overrides = _props$overrides === void 0 ? {} : _props$overrides,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = (0, _reactJss.useTheme)();
  var classes = useStyles(vars.useVars(_objectSpread(_objectSpread({}, (0, _pickAndRemoveFromObject.default)(otherProps, common)), {}, {
    reactionSize: "".concat(theme.iconSizes[size], "px"),
    reactionScale: "scale(".concat(100 / theme.iconSizes.medium * theme.iconSizes[size] / 100, ")"),
    reactionCursor: onClick ? "pointer" : "default",
    reactionFontSize: typeof props.icon === "string" ? theme.iconSizes[size] : "unset"
  })));
  var elm = (0, _react.useRef)(null);
  var showTotal = total === null || total === undefined ? false : true;
  var reactionIcon = icon ? (0, _createIcon.default)(icon) : /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    name: "thumbUp"
  });
  var handleLongPress = function handleLongPress() {
    return onLongPress && onLongPress(elm);
  };
  var handleClick = function handleClick() {
    return onClick && onClick(elm);
  };
  var animation = function animation(node, contents) {
    if (typeof icon !== "string") {
      return;
    }
    var amount = 8;
    var bbox = node.getBoundingClientRect();
    var x = bbox.left + bbox.width / 2;
    var y = bbox.top + bbox.height / 2;
    for (var i = 0; i < amount; i++) {
      (0, _particles.createParticle)(contents, x, y);
    }
  };
  var handlers = (0, _useLongPress.default)({
    onLongPress: handleLongPress,
    onClick: handleClick
  });
  (0, _react.useLayoutEffect)(function () {
    if (acknowledge && elm.current && icon !== null) {
      animation(elm.current, icon);
    }
  }, [icon]);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(classes.variables, classes.root, _defineProperty({}, classes.disabled, disabled), classes[placement], overrides.root, className),
    ref: ref
  }, handlers, otherProps), /*#__PURE__*/_react.default.createElement("span", {
    ref: elm,
    className: (0, _classnames.default)(classes.icon, overrides.icon)
  }, reactionIcon), showTotal && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.total, overrides.total, className)
  }, (0, _shortenNumber.shortenNumber)(total)));
});
var styles = function styles(theme) {
  return {
    "@global": {
      particle: {
        position: "fixed",
        top: 0,
        // eslint-disable-next-line @atg/css-rtl-support
        left: 0,
        opacity: 0,
        pointerEvents: "none"
      }
    },
    variables: vars.styles,
    root: {
      whiteSpace: "nowrap",
      position: "relative",
      cursor: vars.get("reactionCursor"),
      userSelect: "none",
      lineHeight: 1,
      display: "flex",
      alignItems: "center"
    },
    disabled: {
      pointerEvents: "none",
      filter: "grayscale(100%)",
      color: theme.colors.baseContrast050,
      "& svg": {
        fill: theme.colors.baseContrast030,
        borderColor: theme.colors.baseContrast030
      }
    },
    icon: {
      margin: theme.spacing.base / 2,
      fontSize: vars.get("reactionFontSize"),
      lineHeight: 1,
      "& img": {
        width: vars.get("reactionSize"),
        height: vars.get("reactionSize")
      },
      "& svg": {
        fill: theme.colors.baseInvariant,
        width: vars.get("reactionSize"),
        height: vars.get("reactionSize"),
        transform: vars.get("reactionScale")
      }
    },
    total: {
      color: theme.colors.baseInvariant,
      fontSize: vars.get("reactionSize"),
      lineHeight: 1,
      margin: theme.spacing.base / 2
    },
    left: {
      flexDirection: "row"
    },
    right: {
      flexDirection: "row-reverse"
    },
    top: {
      flexDirection: "column-reverse"
    },
    bottom: {
      flexDirection: "column"
    }
  };
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "Reaction"
});
Reaction.displayName = "Reaction";
var Storybook = exports.Storybook = Reaction;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/action-reaction--docs
 */
var exportedComponent = (0, _defaultProps.default)(Reaction);
exportedComponent.displayName = "Reaction";
var _default = exports.default = exportedComponent;